<template>
  <div class="connection-lost-sticker">
    <!-- API error -->
    <span v-if="$store.state.isSyncing === 3 && !$store.state.socketDisconnect">
      <i class="fas fa-times-circle fa-fw" />
      <span>{{ $t('Something went wrong') }}</span>&nbsp;
    </span>

    <!-- Socket error -->
    <span v-if="$store.state.socketDisconnect && $store.state.isSyncing !== 3">
      <span class="loading-spinner black mb--2px" />
      <span>{{ $t("connectionLost") }}</span>&nbsp;
    </span>

    <aha-antd-button
      variant="secondary"
      size="sm"
      class="btn-reload"
      @click="reloadPage"
    >
      {{ $t('Reload') }}
    </aha-antd-button>
  </div>
</template>

<script>
export default {
  methods: {
    reloadPage() {
      window.location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
.connection-lost-sticker {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
